import { encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
    action,
    makeObservable,
    observable,
} from 'mobx';


class FuelConsumptionReportStore {
    loading = false
    fuelconsumptionReport = []
    rootStore

    constructor(rootStore) {
        makeObservable(this, {
            fuelconsumptionReport: observable,
            loadData: action,
            exportExcel: action,
            exportpdf: action
        });
        this.rootStore = rootStore;

    }

    async loadData({ companyId, vehicleId, offset, limit, fromDate, toDate, pageNo }) {
        this.loading = true
        var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo }

        const base64Input = await base64_encode(JSON.stringify(postData));

        var response = await postApi.getClient().post("index.php?c=fuel&a=fuelconsumption", "postData=" + base64Input);

        this.fuelconsumptionReport = response?.data?.data?.fuelconsumption
        this.total = response?.data?.data?.TotalCount
        this.loading = false
    }

    async totalFuelConsumptionReport({ offset, limit, companyId, fromDate, toDate, vehicleId, }) {
        this.loadingData = true
        var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, offset: offset, limit: limit }
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=vehicle&a=totalIdleRep", "postData=" + base64Input);
        this.totalIdleArray = response?.data?.data
        // this.total = parseInt(response?.data?.data?.TotalCount);
        this.loadingData = false;
    }


    async exportExcel(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=vehicle&a=exportcrexcel&cid=" +
            getData.companyId +
            "&userId=" +
            getData.userId +
            "&vid=" +
            getData.vehicleId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }

    async exportpdf(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=vehicle&a=exportcrpdf&cid=" +
            getData.companyId +
            "&userId=" +
            getData.userId +
            "&vid=" +
            getData.vehicleId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }
}

export default FuelConsumptionReportStore;
